/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize AntiBody Anti HBs List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AntiBodyAntiHBsListView';

export const mapStateToPropsAntiBodyAntiHBsList = mapStateToProps;
export const mapDispatchToPropsAntiBodyAntiHBsList = mapDispatchToProps;

export default connect(
  mapStateToPropsAntiBodyAntiHBsList,
  mapDispatchToPropsAntiBodyAntiHBsList
)(View);
